import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { LoginServiceService } from "../Services/login-service.service";
import { CustomServiceService } from "../Services/custom-service.service";
import { User } from "../Services/WOWApi.Service";
@Injectable()
export class CheckOwner  {
    constructor(private router:Router,private loginServiceService:LoginServiceService, private customServices:CustomServiceService) {
 
    }
 
    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): boolean|UrlTree {
        let url: string = state.url;
        var user = this.customServices.GetLoggedInUser() ;
        if (user != null) {
            
            if(user.isOwner)
            {
                return true;
            }          
        } 
        return false; 
 
       
    }
}
